import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import Keycloak from "keycloak-js";
import {computed, inject} from "vue";
import {useUserStore} from "@/stores/UserStore";

// Define types
type PropsType = {
  roles: string[]
}

// Define properties

export default /*#__PURE__*/_defineComponent({
  __name: 'WithRole',
  props: {
    roles: null
  },
  setup(__props: any) {

const props = __props as {
  roles: string[]
};



const userStore = useUserStore()


// Define computed
const hasAnyRole = computed(() => {
  const x = props.roles.filter(role => {
    return userStore.hasRole(role)
  }).length > 0

  console.log('Require role found: ', x)

  return x

})
// Define function


return (_ctx: any,_cache: any) => {
  return (_unref(hasAnyRole))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "withoutRole")
      ]))
}
}

})